module.exports = __webpack_public_path__ + "img/image8-1.19149b40.png";